import Helpers from '@helpers';
import * as React from 'react';
import OrderSummaryHelper from '../../components/order-summary/order_summary';
import ShippingListHelper from '../../components/shipping-list/shipping_list';
import { OrderDetails } from './model';
import NationalCodeModalHelper from '../../components/national-code-modal/national-code-modal';

class OrderDetailsController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        OrderSummaryHelper.setOfficialInvoice(($('#chkOfficialInvoice')[0] as any).checked);
        ShippingListHelper.setOfficialInvoice(($('#chkOfficialInvoice')[0] as any).checked);
        $('#chkOfficialInvoice').change(function() {
            OrderSummaryHelper.setOfficialInvoice((this as any).checked);
            ShippingListHelper.setOfficialInvoice((this as any).checked);
        });

        OrderSummaryHelper.buttonAction = this.buttonAction;
    }

    public render() {
        return null;
    }

    private buttonAction = () => {
        const model: OrderDetails = {
            firstName: Helpers.Utils.convertToString($('#txtfname').val()),
            lastName: Helpers.Utils.convertToString($('#txtlname').val()),
            email: Helpers.Utils.convertToString($('#txtEmail').val()),
            nationalCode: Helpers.Utils.convertToString($('#txtNationalCode').val()),
            mobile: Helpers.Utils.convertToString($('#txtMobile').val()),
            telephone: Helpers.Utils.convertToString($('#txtTelephone').val()),
            addressId: Helpers.Utils.zeroIfEmpty($('#hfdAddressId').val()),
            shippingId: Helpers.Utils.zeroIfEmpty($('#hfdShippingId').val()),
            isFragile: Helpers.Utils.convertToBoolean($('#hfdIsFragile').val()),
            attachInvoice: !$('#chkSendInvoice').is(':checked'),
            isOfficialInvoice: $('#chkOfficialInvoice').is(':checked'),
            voucherCode: Helpers.Utils.convertToString($('#hfdVoucherCode').val()),
            installmentCode: Helpers.Utils.convertToString($('#hdfInstallmentCode').val()),
            notes: Helpers.Utils.convertToString($('#txtUserComment').val()),
            shippingInsurance: Helpers.Utils.convertToBoolean($('#hfdShippingInsurance').val())
        };

        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.saveOrderDetails(model).then(errors => {
            if (errors.Result && errors.Result === "error" && errors.Code == 1) {
                Helpers.LoadingHelper.hideLoading();
                this.openNationalCodeModal();
            }
            else if (errors.length) {
                Helpers.LoadingHelper.hideLoading();
                OrderSummaryHelper.setErrors(errors);
                var error = document.getElementsByClassName('alert');
                var i;
                for (i = 0; i < error.length; i++) {
                    if (window.getComputedStyle(error[i]).display != "none") {
                        error[i].scrollIntoView({ block: "center" });
                    }
                }
                
            } else {
                location.replace('/factor/');
            }
        }).always(_ => {
            // Helpers.LoadingHelper.hideLoading();
        });
    }

    private openNationalCodeModal = () =>
        NationalCodeModalHelper.openNationalCodeModal(this.continueShopping);

    private continueShopping = () => {
        this.buttonAction();
    }
}

Helpers.ReactHelper.createReactElement('OrderDetailsController', OrderDetailsController);